import dayjs from 'dayjs';
import TZ from 'dayjs/plugin/timezone';
import UTC from 'dayjs/plugin/utc';
import Image from 'next/image';
import { FC } from 'react';

import Poster from '~components/ui/Poster';
import { getLinearGradient } from '~components/ui/ShadowImage';
import usePurchase from '~utils/hooks/usePurchase';

import { Attachment, ShowWithMovie } from '~types';

import styles from './ShowHeader.module.css';

interface Props {
  show: ShowWithMovie;
}

dayjs.extend(UTC);
dayjs.extend(TZ);

const ShowSummary: FC<Props> = ({ show }) => {
  const movie = show.Movie;
  const { seats } = usePurchase();

  const dateOfSession = dayjs(show?.rawSchedule, 'YYYY-MM-DD HH:mm').format('dddd, D [de] MMMM');
  const hourOfSession = dayjs(show?.rawSchedule, 'YYYY-MM-DD HH:mm').format('hh:mm a');

  return (
    <header className={styles.root}>
      <Image
        src={movie.banner?.url as string}
        alt={`Imagen promocional de la película ${movie.title}`}
        fill
        className="object-cover opacity-50"
        style={
          movie?.banner?.dominantColors
            ? { backgroundImage: getLinearGradient(movie?.banner?.dominantColors) }
            : {}
        }
      />
      <div className={styles.shadow} />
      <div className={styles.body}>
        <div className={styles.gridContainerSummary}>
          <div className="self-start md:row-span-3">
            <span className={styles.thumbnail}>
              <Poster data={movie.poster as Attachment} />
            </span>
          </div>
          <div className="col-span-5 md:col-span-5">
            <h1 className={styles.title}>{movie.title}</h1>
            <p className={styles.subtitle}>{movie.originalTitle}</p>
          </div>
          <div className="col-span-3 md:col-span-2">
            <p className={styles.summaryTitle}>Fecha</p>
            <span className={styles.summaryData}>{dateOfSession}</span>
          </div>
          <div className="col-span-3 md:col-span-2">
            <p className={styles.summaryTitle}>Hora</p>
            <span className={styles.summaryData}>{hourOfSession}</span>
          </div>
          <div className="col-span-3 md:col-span-1">
            <p className={styles.summaryTitle}>Versión</p>
            <span className={styles.summaryData}>
              {`${show?.Projection?.format}/${show?.Projection?.lang}`}
            </span>
          </div>
          <div className="col-span-3 md:col-span-2">
            <p className={styles.summaryTitle}>Sala</p>
            <span className={styles.summaryData}>{show?.screenName}</span>
          </div>
          <div className="col-span-6 md:col-span-2">
            <p className={styles.summaryTitle}>Asientos</p>
            <span className={styles.summaryData}>{seats?.map((s) => `${s.id}`).join(', ')}</span>
          </div>
          <div className="col-span-6 md:col-span-1">
            <p className={styles.summaryTitle}>Ubicación</p>
            <span className={styles.summaryData}>{show?.Cinema?.name}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default ShowSummary;
